import { SearchOutlined } from "@ant-design/icons";
import { Button, Divider, Input, List, Modal } from "antd";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { GlobalService } from "../../../../util/services/global";
import { propsModal } from "../../../../util/varibles/constants";
import SearchItem from "./SearchItem";
import styles from "./style.module.scss";

const SearchComponent: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<any[]>([]);
    const inputRef = useRef<any>(null);

    useEffect(() => {
        if (!visible)
            return;

        const timer = setTimeout(() => {
            inputRef.current?.focus?.();
        }, 300);

        return () => clearTimeout(timer);
    }, [visible]);

    const openPopup = useCallback(() => {
        setSearchValue('');
        setLoading(false);
        setList([]);
        setVisible(true);
    }, []);

    const closePopup = useCallback(() => setVisible(false), []);

    const handleSearch = useCallback(() => {
        const keyword = searchValue.replace(/^#+/g, '');
        if (keyword.length === 0)
            return;

        setLoading(true);
        GlobalService.search(keyword)
            .then(rs => {
                setList(Array.isArray(rs) ? rs : []);
            })
            .catch(() => undefined)
            .finally(() => {
                setLoading(false);
            });
    }, [searchValue]);

    return <div className={styles['container-search']}>
        <Button className={styles['toggle-search']} onClick={openPopup}>
            <span className={styles.title}>Search in Ocean Planner</span>
            <SearchOutlined className='ml-0' />
        </Button>
        <Modal {...{
            ...propsModal,
            wrapClassName: styles.popupSearch,
            styles: { mask: { background: 'unset' } },
            open: visible,
            centered: false,
            closable: false,
            footer: null,
            onCancel: closePopup
        }}>
            <div className={styles['header-search']}>
                <Input {...{
                    ref: inputRef,
                    id: 'input-search-global',
                    className: styles['input-search'],
                    placeholder: "Type your search here",
                    value: searchValue,
                    onPressEnter: handleSearch,
                    onChange: ({ target }) => setSearchValue(target.value),
                    variant: "borderless",
                    prefix: <SearchOutlined style={{ fontSize: '20px' }} />,
                    suffix: searchValue.length > 0 && <div className='flex align-items-center'>
                        <Button {...{
                            className: 'bt-default',
                            disabled: loading,
                            onClick: () => setSearchValue('')
                        }}>
                            Clear
                        </Button>
                        <Button  {...{
                            loading,
                            className: 'bt-primary ml-16',
                            onClick: handleSearch,
                        }}>
                            Search
                        </Button>
                    </div>
                }} />
                <Divider orientation="vertical" />
                <div className='bt-close' onClick={closePopup} />
            </div>
            <div className={styles['result-search']}>
                <div className={styles['count-search']}>{list.length + ' search results'}</div>
                <List {...{
                    loading,
                    grid: { gutter: 16, column: 2 },
                    dataSource: list,
                    renderItem: (data: any) => <SearchItem {...{ data, closePopup }} />
                }} />
            </div>
        </Modal>
    </div>;
}

export default SearchComponent;
